export const checkIfStringIsValidBoolean = (value: string | null | undefined) =>
	value === "True" ||
	value === "true" ||
	value === (true as unknown as string) ||
	value === "1";
